import React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Button, ButtonProps } from '../Button';

const meta: Meta<typeof Button> = {
  title: 'Components/Button',
  component: Button,
};

export default meta;
type Story = StoryObj<typeof Button>;

export const Default: Story = {
  args: {
    children: 'Click me',
  },
};

function ButtonStory(props: ButtonProps) {
  return (
    // Wrap in `div` so that `flex` doesn't affect `Button`
    <div>
      <Button {...props} />
    </div>
  );
}

export const Variants: Story = {
  render: () => (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <ButtonStory variant="default">Default</ButtonStory>
      <ButtonStory variant="primary">Primary</ButtonStory>
      <ButtonStory variant="secondary">Secondary</ButtonStory>
      <ButtonStory variant="link">Link</ButtonStory>
      <ButtonStory variant="anchor">Anchor</ButtonStory>
    </div>
  ),
};

export const SizeVariants: Story = {
  render: () => (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <ButtonStory size="default">Default</ButtonStory>
      <ButtonStory size="lg">Large</ButtonStory>
      <ButtonStory size="sm">Small</ButtonStory>
    </div>
  ),
};

export const Danger: Story = {
  render: () => (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <ButtonStory variant="default" color="danger">
        Default
      </ButtonStory>
      <ButtonStory variant="primary" color="danger">
        Primary
      </ButtonStory>
      <ButtonStory variant="secondary" color="danger">
        Secondary
      </ButtonStory>
      <ButtonStory variant="link" color="danger">
        Link
      </ButtonStory>
      <ButtonStory variant="anchor" color="danger">
        Anchor
      </ButtonStory>
    </div>
  ),
};

export const Disabled: Story = {
  render: () => (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <ButtonStory variant="default" color="danger" disabled>
        Default
      </ButtonStory>
      <ButtonStory variant="primary" color="danger" disabled>
        Primary
      </ButtonStory>
      <ButtonStory variant="secondary" color="danger" disabled>
        Secondary
      </ButtonStory>
      <ButtonStory variant="link" color="danger" disabled>
        Link
      </ButtonStory>
      <ButtonStory variant="anchor" color="danger" disabled>
        Anchor
      </ButtonStory>
    </div>
  ),
};

export const Anchor: Story = {
  render: () => (
    <ButtonStory variant="anchor" href="https://example.com" target="_blank">
      Anchor
    </ButtonStory>
  ),
};
